import { apiService } from './api';

export interface Feedback {
  id: string;
  rating: number;
  comment?: string;
  customerName?: string;
  customerMobile?: string;
  orderId?: string;
  source?: string;
  organizationCode?: string;
  restaurantId?: string;
  createdAt?: string;
}

export interface FeedbackSummary {
  count: number;
  averageRating: number;
  distribution: number[];   // [1★, 2★, 3★, 4★, 5★]
}

export const feedbackService = {
  async list(org: string, restaurantId?: string, minRating?: number): Promise<Feedback[]> {
    const response = await apiService.get<Feedback[]>('/feedback', {
      org,
      ...(restaurantId && { restaurantId }),
      ...(minRating && { minRating }),
    });
    return response.data;
  },

  async summary(org: string, restaurantId?: string): Promise<FeedbackSummary> {
    const response = await apiService.get<FeedbackSummary>('/feedback/summary', {
      org, ...(restaurantId && { restaurantId }),
    });
    return response.data;
  },

  async create(data: Partial<Feedback> & { rating: number; organizationCode: string }): Promise<Feedback> {
    const response = await apiService.post<Feedback>('/feedback', data);
    return response.data;
  },

  // Public submission from the QR page (no auth)
  async submitPublic(restaurantId: string, data: Partial<Feedback> & { rating: number }): Promise<Feedback> {
    const response = await apiService.post<Feedback>(`/public/restaurant/${restaurantId}/feedback`, data);
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await apiService.delete(`/feedback/${id}`);
  },
};
